import { typographyStyles, tokens, makeStyles } from '@fluentui/react-components';

export const usePageSizeSelectorStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '32px',
    maxWidth: '170px',
    ...typographyStyles.caption1,
    color: tokens.colorNeutralForeground2,
    '& label': {
      marginRight: '5px',
    },
  },
});
